/**
 * Laufzeitkonfiguration.
 *
 * Die Werte kommen aus `/config.json`, die das Deployment neben die Anwendung
 * legt — nicht aus Umgebungsvariablen zur Bauzeit. Dadurch ist derselbe Build
 * überall lauffähig, und die Kennungen stehen an genau einer Stelle.
 */

export interface Config {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  region: string;
}

let geladen: Config | undefined;

export async function ladeConfig(): Promise<Config> {
  if (geladen) return geladen;

  const antwort = await fetch("/config.json", { cache: "no-store" });
  if (!antwort.ok) {
    throw new Error(
      `Konfiguration nicht ladbar (HTTP ${antwort.status}). ` +
        "Im Entwicklungsbetrieb muss public/config.json angelegt sein.",
    );
  }
  geladen = (await antwort.json()) as Config;
  return geladen;
}

export function config(): Config {
  if (!geladen) {
    throw new Error("Konfiguration noch nicht geladen");
  }
  return geladen;
}
